<template>
  <div class="mt90">
    <el-row class="pr-bgimg pr-bg-consult2"></el-row>
    <el-row class="pr-container bg-white mt-160 pb-6">
      <h2 class="page-title">创新技术服务</h2>
      <p class="page-sub-title">Innovative technology services</p>
      <p class="text-center col666 px-6 line-h24">通过创新技术服务帮助客户快速实现业务目标。蒲睿在过往的信息技术服务中，积累了丰富的实战技术资源、专业人才资源，<br/>并构建了成熟的过程实施于质量管控体系。在此基础上，蒲睿通过行业积累，形成了一系列行业解决方案，为金融、制造业、互联网提供专业解决方案及<br/>信息科技服务。蒲睿致力于以信息技术及专业服务助推客户的商业成功，取得共赢。</p>
      <div class="pt-6 px-5 clear mw-img100">
        <el-col class="mb-5 floor-item">
          <h2 ref="tab0" class="font26 f-w500 col333">1) 5S服务保障体系</h2>
          <div class="text-center pt-4"><img src="../../assets/images/newtech/1.png" alt=""></div>
        </el-col>
        <el-col class="mb-5 floor-item">
          <h2 ref="tab1" class="font26 f-w500 col333">2) Speed | 快速响应</h2>
          <div class="text-center pt-4"><img src="../../assets/images/newtech/2.png" alt=""></div>
        </el-col>
        <el-col class="mb-5 floor-item">
          <h2 ref="tab2" class="font26 f-w500 col333">3) Suitable | 高度资源匹配</h2>
          <div class="text-center pt-4"><img src="../../assets/images/newtech/3.png" alt=""></div>
        </el-col>
        <el-col class="mb-5 floor-item">
          <h2 ref="tab3" class="font26 f-w500 col333">4) Suitable | 高度资源匹配</h2>
          <div class="text-center pt-4"><img src="../../assets/images/newtech/4.png" alt=""></div>
        </el-col>
        <el-col class="mb-5 floor-item">
          <h2 ref="tab4" class="font26 f-w500 col333">5) Stable | 人员稳定</h2>
          <div class="text-center pt-4"><img src="../../assets/images/newtech/5.png" alt=""></div>
        </el-col>
        <el-col class="mb-5 floor-item">
          <h2 ref="tab5" class="font26 f-w500 col333">6) Smooth | 平稳交接</h2>
          <div class="text-center pt-4"><img src="../../assets/images/newtech/6.png" alt=""></div>
        </el-col>
        <el-col class="mb-5 floor-item">
          <h2 ref="tab6" class="font26 f-w500 col333">7) 应用开发框架</h2>
          <div class="text-center pt-4"><img src="../../assets/images/newtech/7.png" alt=""></div>
        </el-col>
        <el-col class="mb-5 floor-item">
          <h2 ref="tab7" class="font26 f-w500 col333">8) 大数据分析架构</h2>
          <div class="text-center pt-4"><img src="../../assets/images/newtech/8.png" alt=""></div>
        </el-col>
        <el-col class="mb-5 floor-item">
          <h2 ref="tab8" class="font26 f-w500 col333">9) 区块链技术架构</h2>
          <div class="text-center pt-4"><img src="../../assets/images/newtech/9.png" alt=""></div>
        </el-col>
      </div>
    </el-row>
    <div id="pr-tabs" v-show="prTabShow">
      <el-steps class="pr-tabs-step" direction="vertical" :active="activeStepNum">
        <el-step class="pr-tabs-item" v-for="(item, i) in 9" :key="i" @click.native="tabScroll(i)"></el-step>
      </el-steps>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InnovativeTechService',
  data() {
    return {
      activeStepNum: 1,
      prTabShow: false
    }
  },
  mounted() {
    // 启动监听楼层
    setTimeout(() => {
      this.floorSrcollAddEventListener();
    }, 200);
  },
  methods: {
    // tab切换
    tabScroll(index) {
      let selector = 'tab' + index;
      let top = this.$refs[selector].offsetTop;
      this.$nextTick(()=>{
        // if(document.body) {
        //   document.body.scrollTop = top + 280
        // }else {
        //   // document.documentElement.scroll({
        //   //   top: top + 420,
        //   //   behavior: "smooth"
        //   // })
        //   document.documentElement = top + 280
        // }
        document.body.scroll({
          top: top + 280,
          behavior: "smooth"
        })
        document.documentElement.scroll({
          top: top + 280,
          behavior: "smooth"
        })
      })
    },

    // 监听窗口滚动楼层导航动态定位
    floorSrcollAddEventListener() {
      var that = this;
      let tabs_item  = document.getElementById('pr-tabs').getElementsByClassName('pr-tabs-item');
      let floor_item = document.getElementsByClassName('floor-item');
      that.activeStepNum = 1;
      window.onscroll = function() {
        // nav条控制
        if(document.documentElement.scrollTop || document.body.scrollTop > 2) {
          document.getElementById("prHeader").classList.add('scroll-nav');
        } else {
          document.getElementById("prHeader").classList.remove('scroll-nav');
        }
        // step条出现
        if(document.documentElement.scrollTop || document.body.scrollTop > 300) {
          that.prTabShow = true;
        }else {
          that.prTabShow = false;
        }
        // 控制step当前值
        if(document.documentElement.scrollTop || document.body.scrollTop > 723) {
          // that.posFuseTab = true;
          // 判断滚动条位置-获取元素位置并给楼层高亮
          const window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          for(let i = 0, len = floor_item.length; i < len; i++) {
            const floor_offsetTop = floor_item[i].offsetTop - floor_item[0].offsetTop
            if(window_scrollTop >= floor_offsetTop) {
              for(let n = 0, len = tabs_item.length; n < len; n++) {
                if(that.scrollArivalBottom()) {
                  that.activeStepNum = 9;
                  return
                }
                // DOM.getBoundingClientRect().top 获取元素在窗口实时的位置
                if(floor_item[n].getBoundingClientRect().top < 90) {
                  that.activeStepNum = n + 1;
                }
              }
            }
          }

        }else {
          // that.posFuseTab = false;
        }
      }
    },

    // 监听是否到底部
    scrollArivalBottom() {
      //滚动条在Y轴上的滚动距离
      let getScrollTop = () => {
        let scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0;
        if(document.body){
          bodyScrollTop = document.body.scrollTop;
        }
        if(document.documentElement){
          documentScrollTop = document.documentElement.scrollTop;
        }
        scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
        return scrollTop;
      }
      
      //文档的总高度
      let getScrollHeight = () => {
        let scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
        if(document.body){
          bodyScrollHeight = document.body.scrollHeight;
        }
        if(document.documentElement){
          documentScrollHeight = document.documentElement.scrollHeight;
        }
        scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
        return scrollHeight;
      }
      
      //浏览器视口的高度 
      let getWindowHeight = () => {
        let windowHeight = 0;
        if(document.compatMode == "CSS1Compat"){
          windowHeight = document.documentElement.clientHeight;
        }else{
          windowHeight = document.body.clientHeight;
        }
        return windowHeight;
      }

      if(getScrollTop() + getWindowHeight() == getScrollHeight()) {
        return true // 到底了
      }else {
        return false
      }
    }

  }
}
</script>

<style lang="scss">
.pr-bg-consult2 {
  background-image: url('../../assets/images/consult/1481781005204.jpg');
}
#pr-tabs {
  height: 300px;
  position: fixed;
  top: 50%;
  right: 10px;
  margin-top: -130px;
  z-index: 999;
  .pr-tabs-item {
    cursor: pointer;
  }
  .el-step__head.is-finish {
    color: #fff;
    .el-step__icon.is-text {
      background: #213752;
    }
  }
  .el-step__head.is-process {
    color: #8d8d8d;
    border-color: #8d8d8d;
  }
}
</style>
